let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3Eu7W"), load("7Q0UC"), load("1VNI4")]).then(() => parcelRequire('hC2RX'));